module.exports = __webpack_public_path__ + "img/2.ba1789f3.png";